"use client";

import React, { useCallback, useMemo } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { ImageResponseData } from "@/restapi/image";
import ImageGridCard, {
  ImageGridCardDeleteOptions,
} from "../../../ui/card/ImageGridCard";
import { FilterImageCategory } from "../hooks/useGalleryCategory";
import { User } from "next-auth";

type Props = {
  loadMore: () => void;
  hasMore: boolean;
  items: ImageResponseData[];
  category: FilterImageCategory;
  handleChangeScReenType: (imageId: string) => void;
  className?: string;
  deleteOptions?: ImageGridCardDeleteOptions | undefined;
  user?: User;
  bulkMode?: boolean;
  checkedIds?: number[];
  onToggleCheck?: (imageId: number) => void;
};

const GalleryGrid: React.FC<Props> = ({
  loadMore,
  handleChangeScReenType,
  hasMore,
  category,
  items,
  deleteOptions,
  className = "bg-black",
  bulkMode = false,
  checkedIds = [],
  onToggleCheck,
}) => {
  const handleClick = useCallback(
    (_e: React.MouseEvent<HTMLDivElement>, imageId: string) => {
      handleChangeScReenType(imageId);
    },
    [handleChangeScReenType]
  );

  const scrollKey = useMemo(() => `gallery-${category}`, [category]);

  return (
    <div className={`max-w-5xl flex justify-center ${className} mb-10`}>
      <InfiniteScroll
        key={scrollKey}
        dataLength={items.length}
        next={loadMore}
        hasMore={hasMore}
        loader={<div className="py-6" />}
      >
        <div className="grid grid-cols-3 w-full max-w-5xl mx-auto gap-1">
          {items.map((image) => (
            <ImageGridCard
              deleteOptions={deleteOptions}
              key={image.uuid}
              image={image}
              onClick={handleClick}
              bulkMode={bulkMode}
              checked={checkedIds.includes(image.id)}
              onToggleCheck={onToggleCheck}
            />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default GalleryGrid;